import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../api/api";
import { useTranslation } from "react-i18next";
import ClientProductsModal from "./ClientProductsModal";
import Button from "../UI/Button";
import Card from "../UI/Card";
import ConfirmModal from "../UI/ConfirmModal";



const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const API = `${BASE_URL}/api`;

export default function ClientProductsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(null);

  const [productId, setProductId] = useState("");
  const [price, setPrice] = useState("");
  const [comment, setComment] = useState("");

  const [quantity, setQuantity] = useState(1);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [priceTiers, setPriceTiers] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(null);

 

  const { t } = useTranslation("ClientsPage");

  /* ================= LOAD ================= */
  const load = async () => {
    const res = await authFetch(`${API}/client-prices/?client=${id}`);
    setProducts(await res.json());
  };

  const loadAll = async () => {
    const res = await authFetch(`${API}/products/`);
    setAllProducts(await res.json());
  };

  useEffect(() => {
    load();
    loadAll();
  }, [id]);


/*функция для отображения цены в звависимости от кол-ва */
const getTierPrice = (tiers, qty) => {
  if (!tiers?.length) return 0;
  const tier = tiers.find((t) =>
    qty >= t.min_qty &&
    (t.max_qty === null || qty <= t.max_qty)
  );
  return tier ? Number(tier.price) : 0;
};



  /* ================= SAVE ================= */
  const save = async () => {
    if (!productId || !price) {
      alert("Заполни продукт и цену");
      return;
    }

    // ❗ ЗАЩИТА ОТ ДУБЛЯ (ВАЖНО)
    const alreadyExists = products.find(
      (p) => p.product_detail?.id === Number(productId)
    );

    if (alreadyExists && !editId) {
      alert("Этот продукт уже добавлен клиенту");
      return;
    }

    const payload = {
      client: Number(id),
      product: Number(productId),
      price: Number(price),
      comment: comment || "",

      price_tiers: priceTiers.map((t)=>({
        min_qty: Number(t.min),
        max_qty: t.max ? Number(t.max) : null,
        price: Number(t.price)
      }))
    };

    const url = editId
      ? `${API}/client-prices/${editId}/`
      : `${API}/client-prices/`;

    const method = editId ? "PATCH" : "POST";
   
    console.log("SEND PAYLOAD:", payload);

    const res = await authFetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const text = await res.text();
    console.log("RESPONSE:", res.status, text);

    if (!res.ok) {
      alert("Ошибка сохранения (см. console)");
      return;
    }

    closeModal();
    load();
  };

  /* ================= DELETE ================= */
  const del = async (itemId) => {
    await authFetch(`${API}/client-prices/${itemId}/`, {
      method: "DELETE",
    });

    load();
  };

  /* ================= MODAL ================= */
  const openCreate = () => {
    setEditId(null);
    setProductId("");
    setPrice("");
    setComment("");
    setPriceTiers([]);
    setShow(true);
  };

  const openEdit = (item) => {
    setEditId(item.id);
    setProductId(item.product);
    setPrice(item.price);
    setComment(item.comment || "");
    setPriceTiers(
      item.price_tiers?.map(t => ({
        min: t.min_qty,
        max: t.max_qty || "",
        price: t.price
      })) || []
    );
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
    setEditId(null);
  };

  /* ================= UI ================= */
  return (
    <div className="p-8 pt-20">

      <button onClick={() => navigate("/clients")}>
       ← {t("back")}
      </button>

      <h1 className="text-xl font-bold my-4">
        {t("products_title")} #{id}
      </h1>

      <Button
        variant="primary"
        onClick={openCreate}
      >
        {t("add_product")}
      </Button>

    {/* ================= PRODUCTS ================= */}

    <div className="space-y-4 mt-6">

    {products.map((item) => (

    <Card
      key={item.id}
      hoverable
      className="flex justify-between items-start"
    >

      {/* LEFT BLOCK */}
      <div className="flex gap-4">

        {/* IMAGE */}
        {item.product_detail?.image ? (

          <img
            src={
              item.product_detail.image.startsWith("http")
                ? item.product_detail.image
                : `${BASE_URL}${item.product_detail.image}`
            }
            alt={item.product_detail.name_en}
            className="w-24 h-24 object-cover rounded-xl"
          />

        ) : (

          <div
            className="
              w-24
              h-24
              bg-gray-200
              rounded-xl
              flex
              items-center
              justify-center
              text-gray-500
              text-xs
            "
          >
            Нет фото
          </div>

        )}


        {/* INFO */}
        <div>

          <h2 className="text-lg font-bold">
            {item.product_detail?.name_en}
          </h2>


          <p className="text-lg font-medium text-green-700">
            ¥ {item.price}
          </p>


          <p className="text-gray-500">
            {item.comment || "-"}
          </p>



          {/* PRICE TIERS */}

          {item.price_tiers?.length > 0 && (

            <div
              className="
                mt-3
                p-3
                bg-gray-50
                border
                rounded-xl
              "
            >

              <h4 className="font-semibold mb-2">
                Цена по количеству
              </h4>


              {item.price_tiers.map((tier)=>(

                <div
                  key={tier.id}
                  className="text-sm flex gap-2"
                >

                  <span>
                    {tier.min_qty}
                    {tier.max_qty 
                      ? ` - ${tier.max_qty}`
                      : "+"
                    }
                    {" шт"}
                  </span>


                  <span className="font-semibold text-green-700">
                    {tier.price} ¥
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>



      {/* BUTTONS */}

      <div
        className="flex gap-2"
        onClick={(e)=>e.stopPropagation()}
      >

        <Button
          variant="edit"
          onClick={() => openEdit(item)}
        >
          {t("edit")}
        </Button>


        <Button
          variant="danger"
          onClick={() => setConfirmDelete(item)}
        >
          {t("delete")}
        </Button>
      </div>
    </Card>
    ))}
    </div>
          
      <ClientProductsModal
        show={show}
        editId={editId}

        productId={productId}
        setProductId={setProductId}

        price={price}
        setPrice={setPrice}

        comment={comment}
        setComment={setComment}

        allProducts={allProducts}

        priceTiers={priceTiers}
        setPriceTiers={setPriceTiers}

        save={save}
        closeModal={closeModal}
        t={t}
      />

      <ConfirmModal
      isOpen={!!confirmDelete}
      onClose={() => setConfirmDelete(null)}
      onConfirm={async()=>{
        await del(confirmDelete.id);
        setConfirmDelete(null);
      }}
      title="Удаление продукта"
      description={`Удалить ${confirmDelete?.product_detail?.name_en}?`}
      confirmText="Удалить"
    />

    </div>
  );
}